function getCssProperty(element, property) {
  return window.getComputedStyle(element, null).getPropertyValue(property);
}

/**
 * @typedef {object} textWidthConfig
 * @property {string} text 需测量字符串
 * @property {number} [fontSize=14] 字体大小，默认14px
 * @property {string} [fontWeight='400'] 字体加粗，默认400
 * @property {string} fontFamily 字体
 * @property {HTMLElement} element 字体所处dom
 */

/**
 * 测量字符串长度
 * @param {textWidthConfig} textWidthConfig
 * @return {number} 字体长度
 */
function textWidth(textWidthConfig) {
  const { text, fontSize, fontFamily, element, fontWeight } = textWidthConfig;
  const canvas =
    textWidth.canvas || (textWidth.canvas = document.createElement("canvas"));
  const tmpFontFamily =
    fontFamily ||
    getCssProperty(element || window.document.body, "font-family");
  const tmpFontSize =
    fontSize ||
    Number(
      getCssProperty(element || window.document.body, "font-size").replace(
        /px$/,
        ""
      )
    );
  const tmpFontWeight =
    fontWeight ||
    getCssProperty(element || window.document.body, "font-family");

  const context = canvas.getContext("2d");
  context.font = `${tmpFontWeight} ${tmpFontSize}px ${tmpFontFamily}`;
  const metrics = context.measureText(text);
  return metrics.width;
}

export default textWidth;
